import { Container } from "reactstrap"
import { useTranslation, withTranslation } from "react-i18next"
import { FaBoxOpen, FaChartBar, FaClock, FaMicroscope } from "react-icons/fa"

const AnalyseMicrobiote = () => {
    const { t } = useTranslation()

    return (
        <div className="bg-white py-5">
            <Container style={{ maxWidth: "900px" }}>
                <h2 className="text-center mb-4 dark-blue">{t("microbiote|Tout savoir sur l’analyse du microbiote intestinal à domicile")}</h2>
                <p className="text-justify">{t("microbiote|Intro")}</p>

                <h2 className="mt-5 mb-4 dark-blue">{t("microbiote|Pourquoi analyser votre microbiote ?")}</h2>
                <div className="ml-3">
                    <h3 className="mt-4 h3-override dark-blue">1. {t("microbiote|Identifier l’origine de vos troubles digestifs")}</h3>
                    <p>{t("microbiote|Texte 1")}</p>

                </div>
                <div className="ml-3">
                    <h3 className="mt-4 h3-override dark-blue">2. {t("microbiote|Recevoir des conseils nutritionnels ciblés")}</h3>
                    <p>{t("microbiote|Texte 2")}</p>
                </div>
                <div className="ml-3">
                    <h3 className="mt-4 h3-override dark-blue">3. {t("microbiote|Prévenir les déséquilibres et booster votre immunité")}</h3>
                    <p>{t("microbiote|Texte 3")}</p>
                </div>

                <h2 className="mt-5 mb-4 dark-blue">{t("microbiote|Comment fonctionne le test Nahibu ?")}</h2>
                <ul className="checklist">
                    <li><FaBoxOpen className="icon-fix-small mr-1 dark-blue fix-icon-pad" /> {t("microbiote|Étape 1")}</li>
                    <li><FaClock className="icon-fix-small mr-1 dark-blue fix-icon-pad" /> {t("microbiote|Étape 2")}</li>
                    <li><FaMicroscope className="icon-fix-small mr-1 dark-blue fix-icon-pad" /> {t("microbiote|Étape 3")}</li>
                    <li><FaChartBar className="icon-fix-small mr-1 dark-blue fix-icon-pad" /> {t("microbiote|Étape 4")}</li>
                </ul>


                <h2 className="mt-5 pb-4 text-center dark-blue">{t("microbiote|Comment réaliser votre prélèvement à domicile, étape par étape")}</h2>
                <div className="video-wrapper text-center ">
                    <iframe
                        width="80%"
                        height="300"
                        src="https://www.youtube.com/embed/ufIcm4krV-s"
                        title={t("microbiote|Comment réaliser votre prélèvement à domicile, étape par étape")}
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    ></iframe>
                </div>
            </Container>
        </div>
    )
}

export default withTranslation()(AnalyseMicrobiote)
